export default __webpack_public_path__ + "assets/32f9cf488c35e9269a06b946b095b563.png";